import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import router from './router'
import { createPinia } from 'pinia'
import VueSmoothScroll from 'v-smooth-scroll'

createApp(App).use(createPinia()).use(router).use(Quasar, quasarUserOptions).use(VueSmoothScroll).mount('#app')
